import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import service from '@services/passenger-bus'

export const fetchPlaces = createAsyncThunk('places/fetch', async (params, { rejectWithValue }) => {
  try { const res = await service.getPlaces(params); return { params, data: res.data, meta: res.meta } } catch (e) { return rejectWithValue(e.response?.data || e.message) }
})
export const fetchPlace = createAsyncThunk('places/fetchOne', async (id, { rejectWithValue }) => { try { return await service.getPlace(id) } catch (e) { return rejectWithValue(e.response?.data || e.message) } })
export const addPlace = createAsyncThunk('places/add', async (payload, { rejectWithValue }) => { try { return await service.addPlace(payload) } catch (e) { return rejectWithValue(e.response?.data || e.message) } })
export const savePlace = createAsyncThunk('places/save', async (payload, { rejectWithValue }) => { try { return await service.updatePlace(payload) } catch (e) { return rejectWithValue(e.response?.data || e.message) } })
export const removePlace = createAsyncThunk('places/remove', async (id, { rejectWithValue }) => { try { await service.deletePlace(id); return id } catch (e) { return rejectWithValue(e.response?.data || e.message) } })

const slice = createSlice({
  name: 'places',
  initialState: { data: [], meta: null, params: { page: 1, take: 10, order: 'ASC', q: '' }, selected: null, loading: false, error: null },
  reducers: { setPlaceParams(s, a) { s.params = a.payload } },
  extraReducers: b => {
    b.addCase(fetchPlaces.pending, s => { s.loading = true })
     .addCase(fetchPlaces.fulfilled, (s, a) => { s.loading = false; s.data = a.payload.data; s.meta = a.payload.meta; s.params = a.payload.params })
     .addCase(fetchPlaces.rejected, (s, a) => { s.loading = false; s.error = a.payload })
     .addCase(fetchPlace.fulfilled, (s, a) => { s.selected = a.payload })
     .addCase(addPlace.fulfilled, (s, a) => { s.data.unshift(a.payload) })
     .addCase(savePlace.fulfilled, (s, a) => { const i = s.data.findIndex(x => x.id === a.payload.id); if (i > -1) s.data[i] = a.payload })
     .addCase(removePlace.fulfilled, (s, a) => { s.data = s.data.filter(x => x.id !== a.payload) })
  }
})

export const { setPlaceParams } = slice.actions
export default slice.reducer
